'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { useCart } from '@/app/_lib/hooks/useCart';
import { useGlobalMessage } from '@/app/_lib/hooks';
const PromoCode = t0 => {
  const $ = _c(81);
  const {
    onPromotionChange,
    className
  } = t0;
  const {
    cart,
    promotion,
    applyPromotion,
    clearPromotion,
    isTradeCustomer
  } = useCart();
  const [promoCode, setPromoCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const inputRef = useRef(null);
  const addGlobalMessage = useGlobalMessage();
  let t1;
  let t2;
  if ($[0] !== onPromotionChange || $[1] !== promotion) {
    t1 = () => {
      if (onPromotionChange) {
        onPromotionChange(promotion);
      }
    };
    t2 = [promotion, onPromotionChange];
    $[0] = onPromotionChange;
    $[1] = promotion;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== isExpanded || $[5] !== promotion) {
    t3 = () => {
      if (isExpanded && !promotion && inputRef.current) {
        setTimeout(() => {
          inputRef.current?.focus();
        }, 100);
      }
    };
    t4 = [isExpanded, promotion];
    $[4] = isExpanded;
    $[5] = promotion;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  if (isTradeCustomer) {
    return null;
  }
  let t5;
  if ($[8] !== addGlobalMessage || $[9] !== applyPromotion || $[10] !== promoCode) {
    t5 = async e => {
      e.preventDefault();
      if (!promoCode.trim()) {
        setError("Please enter a promotion code.");
        return;
      }
      setIsLoading(true);
      const response = await applyPromotion(promoCode.trim());
      if (response.success) {
        setPromoCode("");
        setIsExpanded(false);
        addGlobalMessage({
          message: "Promotion code applied!",
          messageType: "success"
        });
      } else {
        setError(response.message || "Promotion code not valid.");
      }
      setIsLoading(false);
    };
    $[8] = addGlobalMessage;
    $[9] = applyPromotion;
    $[10] = promoCode;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleSubmit = t5;
  let t6;
  if ($[12] !== addGlobalMessage || $[13] !== clearPromotion) {
    t6 = async () => {
      setIsLoading(true);
      const success = await clearPromotion();
      if (success) {
        setError("");
        addGlobalMessage({
          message: "Promotion code removed.",
          messageType: "success"
        });
      }
      setIsLoading(false);
    };
    $[12] = addGlobalMessage;
    $[13] = clearPromotion;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleRemove = t6;
  let t7;
  if ($[15] !== isExpanded) {
    t7 = () => {
      setIsExpanded(!isExpanded);
      setError("");
    };
    $[15] = isExpanded;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const toggleExpanded = t7;
  const showCollapsed = !promotion && !isExpanded;
  const showExpanded = !promotion && isExpanded;
  const showApplied = !!promotion;
  const t8 = `relative ${className || ""}`;
  const t9 = `transition-opacity duration-300 ${showCollapsed ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t10;
  if ($[17] !== toggleExpanded) {
    t10 = <button type="button" onClick={toggleExpanded} className="text-sm text-light underline hover:text-dark">Apply Promotion Code</button>;
    $[17] = toggleExpanded;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className={t9}>{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = `transition-opacity duration-700 ${showExpanded ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_0 => setPromoCode(e_0.target.value);
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isLoading || $[24] !== promoCode) {
    t14 = <input ref={inputRef} type="text" id="promo_code_input" value={promoCode} onChange={t13} className="material-input peer pr-8" placeholder=" " disabled={isLoading} />;
    $[23] = isLoading;
    $[24] = promoCode;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <label htmlFor="promo_code_input" className="material-input-label peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-not-placeholder-shown:material-input-label-float">Promotion Code</label>;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== isLoading) {
    t16 = isLoading ? <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" /> : "Apply";
    $[27] = isLoading;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== isLoading || $[30] !== t16) {
    t17 = <button type="submit" disabled={isLoading} className="absolute right-0 top-1/2 -translate-y-1/2 text-xs text-light hover:text-primary transition-colors disabled:opacity-50">{t16}</button>;
    $[29] = isLoading;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t14 || $[33] !== t17) {
    t18 = <div className="material-input-group">{t14}{t15}{t17}</div>;
    $[32] = t14;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== handleSubmit || $[36] !== t18) {
    t19 = <form onSubmit={handleSubmit}>{t18}</form>;
    $[35] = handleSubmit;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  const t20 = `text-red text-xs transition-opacity duration-200 ${error ? "opacity-100" : "opacity-0"}`;
  const t21 = error || "\xA0";
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = <span className={t20}>{t21}</span>;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== toggleExpanded) {
    t23 = <button type="button" onClick={toggleExpanded} className="text-xs text-light underline hover:text-dark">Cancel</button>;
    $[41] = toggleExpanded;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t22 || $[44] !== t23) {
    t24 = <div className="flex items-end justify-between mt-1">{t22}{t23}</div>;
    $[43] = t22;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t12 || $[47] !== t19 || $[48] !== t24) {
    t25 = <div className={t12}>{t19}{t24}</div>;
    $[46] = t12;
    $[47] = t19;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  const t26 = `transition-opacity duration-300 ${showApplied ? "opacity-100" : "opacity-0 absolute inset-0 pointer-events-none"}`;
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <span className="text-sm font-medium">Promotion Code:</span>;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  const t28 = promotion?.promotion_code;
  let t29;
  if ($[51] !== t28) {
    t29 = <div>{t27}<span className="text-sm ml-1 uppercase">{t28}</span></div>;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== isLoading) {
    t30 = isLoading ? <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" /> : "remove";
    $[53] = isLoading;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  let t31;
  if ($[55] !== handleRemove || $[56] !== isLoading || $[57] !== t30) {
    t31 = <button type="button" onClick={handleRemove} className="text-xs text-light underline hover:text-dark transition-colors" disabled={isLoading}>{t30}</button>;
    $[55] = handleRemove;
    $[56] = isLoading;
    $[57] = t30;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== t29 || $[60] !== t31) {
    t32 = <div className="flex items-center justify-between">{t29}{t31}</div>;
    $[59] = t29;
    $[60] = t31;
    $[61] = t32;
  } else {
    t32 = $[61];
  }
  let t33;
  if ($[62] !== cart || $[63] !== promotion) {
    t33 = promotion?.messages && promotion.messages.length > 0 && <div className="mt-1">{promotion.messages.map((message, index) => {
        const isDiscountAppliedMessage = message.toLowerCase().includes("discount applied");
        if (isDiscountAppliedMessage && (!cart?.discount || cart.discount === 0)) {
          return null;
        }
        return <div key={index} className={`text-xs ${promotion.requires_login ? "text-light" : "text-green-600"}`}>{message}</div>;
      })}</div>;
    $[62] = cart;
    $[63] = promotion;
    $[64] = t33;
  } else {
    t33 = $[64];
  }
  let t34;
  if ($[65] !== cart?.hasSaleItems || $[66] !== promotion) {
    t34 = promotion && !promotion.requires_login && cart?.hasSaleItems && <div className="mt-1 text-xs text-red lowercase">some items in your cart do not qualify for the promotion</div>;
    $[65] = cart?.hasSaleItems;
    $[66] = promotion;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== promotion?.requires_login) {
    t35 = promotion?.requires_login && <div className="mt-1 text-xs text-light"><a href="/account/sign-in" className="underline text-primary">Sign in</a> to apply this discount.</div>;
    $[68] = promotion?.requires_login;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== t26 || $[71] !== t32 || $[72] !== t33 || $[73] !== t34 || $[74] !== t35) {
    t36 = <div className={t26}>{t32}{t33}{t34}{t35}</div>;
    $[70] = t26;
    $[71] = t32;
    $[72] = t33;
    $[73] = t34;
    $[74] = t35;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] !== t11 || $[77] !== t25 || $[78] !== t36 || $[79] !== t8) {
    t37 = <div className={t8}>{t11}{t25}{t36}</div>;
    $[76] = t11;
    $[77] = t25;
    $[78] = t36;
    $[79] = t8;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  return t37;
};
export default PromoCode;